import { MRT_PaginationState } from "material-react-table";
import { useQuery } from "react-query";
import { getDomesticBranches } from "./gateway";

function useGetDomesticBranches(pagination: MRT_PaginationState) {
  return useQuery({
    queryFn: () => getDomesticBranches(pagination),
    queryKey: ["getDomesticBranches", pagination],
  });
}

export default useGetDomesticBranches;
